import React from "react";

const ContactForm = () => {
  return (
    <section className="tw-w-full tw-py-16 tw-px-4 md:tw-px-32">
      <h2 className="tw-text-3xl tw-font-bold tw-text-center tw-mb-8">
        Contact Us
      </h2>
      <form
        className="tw-max-w-3xl tw-mx-auto tw-bg-white tw-shadow-lg tw-rounded-xl tw-p-8 tw-space-y-6"
        action="mailto:demipeju.awe@gmail.com"
        method="POST"
        encType="text/plain"
      >
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
          <input
            type="text"
            name="Full Name"
            placeholder="Full Name"
            required
            className="tw-flex-1 tw-p-3 tw-border tw-rounded-lg"
          />
          <input
            type="email"
            name="Email"
            placeholder="Email"
            required
            className="tw-flex-1 tw-p-3 tw-border tw-rounded-lg"
          />
        </div>

        <select
          name="Reason"
          required
          className="tw-w-full tw-p-3 tw-border tw-rounded-lg"
        >
          <option value="">Select a reason</option>
          <option>Website issues</option>
          <option>Project Discussion</option>
          <option>Warranty</option>
          <option>Orders</option>
        </select>

        <textarea
          name="Enquiry"
          rows="5"
          placeholder="Your enquiry..."
          required
          className="tw-w-full tw-p-3 tw-border tw-rounded-lg"
        />

        <div className="tw-flex tw-justify-end">
          <button
            type="submit"
            className="tw-bg-[#00B5ED] tw-text-white tw-px-6 tw-py-2 tw-rounded-md tw-font-semibold tw-transition-all hover:tw-scale-105"
          >
            Submit
          </button>
        </div>
      </form>
    </section>
  );
};

export default ContactForm;
